import { createApp } from 'vue'
import App from './App.vue'
import Vue3Lottie from 'vue3-lottie'

var vm = createApp(App).use(Vue3Lottie);
// eslint-disable-next-line
const vue_root = vm.mount('#app');
